import React from "react";
import { Link, NavLink } from "react-router-dom";
import About from "./About";
import "./Footer.css";
import Klarna from "../logopack/Klarna.svg";
import Trygg from "../logopack/Trygg.svg";
import Media from "../logopack/media.png";
import AffiliateBanners from "./AffiliateBanners";


function Footer() {
  return (
    <div className="wrapper">
      <div className="footer__container">
        <div className="info__box">
          <p className="info__head">
            <Link to="/about">Om Isaks Bilar</Link>
          </p>
          <ul>
            <li>Vår historia</li>
            <li>Varför Isaks Bilar</li>
            <li>Vårt samarbete med Leksaksbilar.se</li>
          </ul>
        </div>
        <div className="info__box">
          <p className="info__head cus-service">
            <Link to="/customer">Kundservice</Link>
          </p>
          <ul>
            <li>Kontakta oss</li>
            <li>Frågor och svar</li>
            <li>Produktinformation</li>
          </ul>
        </div>
        <div className="info__box">
          <p className="info__head">
            <Link to="/howto">Så handlar du</Link>
          </p>
          <ul>
            <li>Betalning via Leksaksbilar.se</li>
            <li>Leveransinformation</li>
            <li>Ångerrätt/Returer</li>
            <li>Köpvillkor</li>
          </ul>
        </div>
        <div className="info__box">
          <p className="info__head">
            <Link to="/club">Samarbetspartners</Link>
          </p>
          <ul>
            <li>Leksaksbilar.se</li>
            <li>Adtraction Affiliate</li>
            <li>Bli partner</li>
          </ul>
        </div>
        <div className="info__box shadow-box">
          <p className="info__head kontakt-head">Kontakt</p>
          <ul>
            <li className="email">info@isaksbilar.se</li>
            <li>Online butik</li>
            <li>Alltid tillgänglig</li>
          </ul>
        </div>
      </div>
      <AffiliateBanners type="medium" />
      <div className="payment__box">
        <img className="img klarna" src={Klarna}></img>
        <img className="img trygg" src={Trygg}></img>
        <img className="img img-png" src={Media}></img>
      </div>
      <div className="copy-right">
        <p className="cr-text">
          Isaksbilar.se - Affiliate partner för Leksaksbilar.se - Copyright © {new Date().getFullYear()} - All rights
          reserved - Developed by{' '}
          <a href="https://www.yoseph.dev/" target="_blank" rel="noopener noreferrer">
            Yoseph Berhane
          </a>
        </p>
      </div>
    </div>
  )
}

export default Footer;
